import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {KfRegistrationSearch} from '../../../../shared/models/kf-registration-search.interface';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-kf-registration-admin-filters',
  templateUrl: './kf-registration-admin-filters.component.html',
  styleUrls: ['./kf-registration-admin-filters.component.scss']
})
export class KfRegistrationAdminFiltersComponent implements OnInit {

  searchForm = this.formBuilder.group({
    startYear: [''],
    endYear: [''],
    entry: [''],
    keyFigures: [''],
    b2bb2c: [''],
    status: [],
    schemaKind: []
  });

  get startYearControl(): FormControl {
    return this.searchForm.get('startYear') as FormControl;
  }

  get endYearControl(): FormControl {
    return this.searchForm.get('endYear') as FormControl;
  }

  get entryControl(): FormControl {
    return this.searchForm.get('entry') as FormControl;
  }

  get keyFiguresControl(): FormControl {
    return this.searchForm.get('keyFigures') as FormControl;
  }

  get b2bb2cControl(): FormControl {
    return this.searchForm.get('b2bb2c') as FormControl;
  }

  get statusControl(): FormControl {
    return this.searchForm.get('status') as FormControl;
  }

  get schemaKind(): FormControl {
    return this.searchForm.get('schemaKind') as FormControl;
  }

  @Input()
  showStatus!: boolean;
  @Output()
  search: EventEmitter<KfRegistrationSearch> = new EventEmitter<KfRegistrationSearch>();

  allListFilter!: boolean;

  constructor(private formBuilder: FormBuilder,
              private readonly activatedRoute: ActivatedRoute,
              private readonly router: Router) {
    this.allListFilter = this.router.url.endsWith('all');
  }

  ngOnInit(): void {
    this.setFormValuesFromQueryParams();
  }

  handleSubmit(): void {
    const dto: KfRegistrationSearch = {
      startYear: this.startYearControl.value,
      endYear: this.endYearControl.value,
      entry: this.entryControl.value,
      keyFigures: this.keyFiguresControl.value,
      b2bb2c: this.b2bb2cControl.value,
      status: this.statusControl.value,
      schemaKind: this.schemaKind.value
    };
    this.search.emit(dto);
  }

  clean(): void {
    this.search.emit({});
  }

  private setFormValuesFromQueryParams(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.startYear) {
        this.searchForm.get('startYear')?.setValue(params.startYear);
      }
      if (params.endYear) {
        this.searchForm.get('endYear')?.setValue(params.endYear);
      }
      if (params.keyFigures) {
        this.searchForm.get('keyFigures')?.setValue(params.keyFigures);
      }
      if (params.b2bb2c) {
        this.searchForm.get('b2bb2c')?.setValue(params.b2bb2c);
      }
      if (params.status) {
        this.searchForm.get('status')?.setValue(params.status);
      }
      if (params.entry) {
        this.searchForm.get('entry')?.setValue(params.entry);
      }
      if (params.schemaKind) {
        this.searchForm.get('schemaKind')?.setValue(params.schemaKind);
      }
    });
  }

}
